import { useContext } from 'react';
import { StoreContext } from '@roc/feature-app-core';
import { InternalSecondAppraisalStore } from '../stores/internalSecondAppraisalStore';

export const useInternalSecondAppraisalStore = () =>
  useContext<{
    internalSecondAppraisalStore: InternalSecondAppraisalStore;
  }>(StoreContext);